/*!
 *  (c)(r) 2008-2021 IT-Service Robert Frunzke
 */

import { MDLocaleBase } from './locale-base.js';

let MDLocale = MDLocaleBase.get_impl();

export {
	MDLocale
};
